<template>
    <div id="app">
        <router-view />

        <div class="alert-content">
            <vue-alert />
        </div>
    </div>
</template>

<script>
export default {
    name: "App"
};
</script>
